class MobileDrawer extends HTMLElement {
    constructor() {
        super();
        this.button = document.querySelector('.mobile-sidebar-menu');
        this.hamburger = this.button.querySelector('.icon-hamburger');
        this.close = this.button.querySelector('.icon-close');
        this.headerLinks = document.querySelectorAll('header .header .tap-area:not(.mobile-sidebar-menu)');
        this.overlay = document.querySelector('.mobile-drawer-overlay')

        this.button.addEventListener("click", this.toggleDrawer.bind(this));
        this.headerLinks.forEach(headerLink => {
            headerLink.addEventListener("click", this.closeDrawer.bind(this));
        });
        this.overlay.addEventListener("click", this.closeDrawer.bind(this));
    }

    toggleDrawer() {
        const isOpen = this.classList.toggle('open');
        
        document.body.style.overflow = isOpen ? 'hidden' : '';
        this.hamburger.style.display = isOpen ? 'none' : 'block';
        this.close.style.display = isOpen ? 'block' : 'none';
        this.overlay.classList.toggle('hidden')
    }

    closeDrawer() {
        const isOpen = this.classList.contains('open');
        console.log('isOpen', isOpen)
        if (!isOpen) return

        document.body.style.overflow = '';
        this.classList.remove('open');
        this.overlay.classList.add('hidden')
        this.hamburger.style.display = 'block';
        this.close.style.display = 'none';
    }
}

customElements.define('mobile-drawer', MobileDrawer);